const indentColors = [
  {
    id: 0,
    color: 'status-purple',
  },
  {
    id: 29,
    color: 'status-teal',
  },
  {
    id: 8,
    color: 'status-red',
  },
  {
    id: 30,
    color: 'status-blue',
  },
  {
    id: 34,
    color: 'status-lightgrey',
  },
  {
    id: 35,
    color: 'status-lightgrey',
  },
  {
    id: 36,
    color: 'status-red',
  },
];

module.exports = indentColors;
